export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_13.9f4479eb.png";